//import 'froala-editor/js/froala_editor.pkgd.min.js';
//import 'froala-editor/js/plugins.pkgd.min.js';

import PerfectScrollbar from 'perfect-scrollbar';

//Sweet Alert
//window.swal = require('sweetalert2');

// Clipboard JS
//window.ClipboardJS = require('clipboard');
window.moment = require('moment');
window.numeral = require('numeral');
window.PerfectScrollbar = PerfectScrollbar;
window.pubsub = require('pubsub.js');
window.uniqid = require('uniqid');
window.URI = require('urijs');

require('./bootstrap');
require('mdbootstrap-pro');

//require('active-timeout');
require('bootstrap-colorpicker');
//require('cleave.js');
//require('donleeve');
require('icheck');
require('jquery-validation');
//require('jquery-form');
//require('jquery-match-height');
//require('select2');
require('slick-carousel');
//require('waypoints');


require('./react/components/Snackbar');

require('./components/CartIndex/App');
require('./components/CartWidget/App');
require('./components/DestinationMenu/App');
require('./components/ContactUsModal');
require('./components/EmailToBookModal');
require('./components/MenuEditor/App');
require('./components/Shortcodes/Carousel');
require('./components/Shortcodes/PostsCarousel');
require('./components/Shortcodes/ReviewsCarousel');
require('./components/Shortcodes/Slider');
require('./components/Shortcodes/ToursCarousel');
require('./components/Shortcodes/ToursCleanCarousel');
require('./components/Shortcodes/ToursColumn');
require('./components/Shortcodes/ToursList');
require('./components/TourOrderer/App');
// require('./components/ToursIndex/App');
require('./components/BookingWidget/BookingWidget');
require('./components/ToursShow/App');
require('./components/EntryPage');
require('./components/Shortcodes/Excursions');
require("./components/OrderNowModal");


require('./react/components/ToursIndex');



require('./components/Shortcodes/TourDescription.jsx')
require('./components/Shortcodes/TourDetails.jsx')
require('./components/Shortcodes/TourImageBoard.jsx')



// WEBPACK FOOTER //
// ./resources/js/app.js